<template>
    <div>
        <MulReportHeader :dataFrom="table.params" @search="searchData" :toPdf="toPdf" :excelShow="false"></MulReportHeader>
        <Collapse v-model="panelName">
            <Panel v-for="(item, index) in table.data" :key="index" :name="`${item.platid}`">
                <span slot>{{ item.platname }}</span>
                <div slot="content">
                    <div v-for="(temp, count) in item.data">
                        <div class="table-title">{{ temp.app_name }}</div>
                        <Table border :columns="table.columns" :data="temp.data"></Table>
                    </div>
                </div>
            </Panel>
        </Collapse>
    </div>
</template>

<script>
import MulReportHeader from './components/mul_report_header.vue'
import { TransTopReq } from '@/api/admin/risk'
export default {
    name: 'HandicapRGamerData',
    components: { MulReportHeader },
    data() {
        return {
            panelName: [],
            loading: false,
            timestamp: 0,
            TransTopReqTimer: null,
            table: {
                params: {
                    platids: [],
                    app_id: 0,
                    app_ids: [],
                    type_list: ['小小R', '小R', '中小R', '中R', '中大R', '大R', '合计'],
                    dataTime: this.getCurrentZeroDay()
                },
                data: [],
                columns: [
                    {
                        key: 'time',
                        width: 90,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '日期', '显示对应的盘口名称')
                    },
                    {
                        key: 'r_name',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, 'R级别', '转入级别')
                    },
                    {
                        key: 'pay_num',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入人数', '转入人数'),
                        render: (h, params) => this.rColItem(h, params)
                    },
                    {
                        key: 'pay_ave',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '人均转入金额', '人均转入金额'),
                        render: (h, params) => this.rColItem(h, params)
                    },
                    // {
                    //     key: 'pay_put_rate',
                    //     minWidth: 80,
                    //     align: 'center',
                    //     renderHeader: (h) => this.renderHeader(h, '充提差转入比', '充提差转入比'),
                    //     render: (h, params) => this.rColItem(h, params),
                    // },
                    // {
                    //     key: 'win_rate',
                    //     minWidth: 80,
                    //     align: 'center',
                    //     renderHeader: (h) => this.renderHeader(h, '当天游戏赢家数占比', '当天游戏赢家数占比'),
                    //     render: (h, params) => this.rColItem(h, params),
                    // },
                    {
                        key: 'diff_rate',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '当天充提差赢家数占比', '当天充提差赢家数占比'),
                        render: (h, params) => this.rColItem(h, params)
                    },
                    {
                        key: 'pay_put_user_rate',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '转入转出比', '转入转出比'),
                        render: (h, params) => this.rColItem(h, params)
                    },
                    {
                        key: 'loss_rate',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '游戏盈利率', '（投注-返奖）/投注'),
                        render: (h, params) => this.rColItem(h, params)
                    },
                    {
                        key: 'pay_bet',
                        minWidth: 80,
                        align: 'center',
                        renderHeader: (h) => this.renderHeader(h, '投注转入比', '总投注/总转入'),
                        render: (h, params) => this.rColItem(h, params)
                    }
                    // {
                    //     key: 'online_pay_rate',
                    //     minWidth: 80,
                    //     align: 'center',
                    //     renderHeader: (h) => this.renderHeader(h, '线上转入成功率', '线上转入订单转入率= 成功订单数 / 总订单数'),
                    //     render: (h, params) => this.rColItem(h, params),
                    // },
                ]
            }
        }
    },
    methods: {
        //关闭定时器
        closeTimer() {
            this.loading = false
            clearTimeout(this.TransTopReqTimer)
            this.TransTopReqTimer = null
        },
        //批量请求开启定时器8秒超时
        openTimer() {
            this.closeTimer()
            this.loading = true
            this.TransTopReqTimer = setTimeout(() => {
                this.loading = false
            }, 8000)
        },
        getTransTopParams(func, _param) {
            return {
                mod: 'root',
                platid: _param.platid,
                app_id: _param.app_id,
                app_name: _param.app_name,
                platname: _param.platname,
                timestamp: _param.timestamp,
                param: {
                    _mod: 'manager',
                    _func: func,
                    _param
                }
            }
        },

        async searchData(emitProps) {
            let allList = this.getAllHttpAppid(this.table.params)
            let httpList = []

            let loadingArr = [...allList]
            let stime = this.getSecond(this.table.params.dataTime)
            let etime = this.getSecond(this.table.params.dataTime, false)
            let timestamp = new Date().getTime()
            this.timestamp = timestamp
            for (let i = 0, len = allList.length; i < len; i++) {
                let app_id = allList[i]
                let item = emitProps.app_list.find((el) => el.appid == app_id)
                let app_name = item.appName
                let platid = item.platform
                let platname = emitProps.plat_list.find((el) => el.id == platid).name
                let param = this.getTransTopParams('GetNewPlatformRmbPlayerData', {
                    platid,
                    app_id,
                    app_name,
                    platname,
                    stime: this.getSecond(this.table.params.dataTime),
                    etime: this.getSecond(this.table.params.dataTime, false),
                    timestamp,
                    mix_point: 0.01,
                    general: -1,
                    pack_no: -1
                })
                httpList.push(param)
            }
            this.openTimer()
            this.table.data = []
            this.panelName = []
            for (let s = 0; s < 5; s++) {
                this.toHttp(httpList, loadingArr)
            }
        },
        async toHttp(httpList, loadingArr) {
            if (httpList.length > 0) {
                let params = httpList.shift()
                let timestamp = params.timestamp
                TransTopReq(params).then((res) => {
                    let params1 = this.copyData(params)
                    params1.param._param.stime -= 24 * 60 * 60
                    params1.param._param.etime -= 24 * 60 * 60
                    TransTopReq(params1).then((res1) => {
                        let params2 = this.copyData(params)
                        params2.param._func = 'GetNewPlatfromData'
                        TransTopReq(params2).then((res2) => {
                            let params3 = this.copyData(params1)
                            params3.param._func = 'GetNewPlatfromData'
                            TransTopReq(params3).then((res3) => {
                                if (timestamp == this.timestamp) {
                                    let tData = res._param.data
                                    let yData = res1._param.data
                                    let result = {
                                        app_id: params.app_id,
                                        app_name: params.app_name,
                                        data: []
                                    }
                                    for (let i = 0; i < tData.length; i++) {
                                        if (tData[i].sub_data) {
                                            let tItem = tData[i].sub_data[0]
                                            let yItem = yData[i].sub_data[0]
                                            let data = { type: 0 } //今日数据
                                            data.r_name = this.table.params.type_list[i]
                                            data.time = tItem.pay_range
                                            let dataComp = {} //昨日数据
                                            this.getNeedField(data, tItem)
                                            this.getNeedField(dataComp, yItem)
                                            data.online_pay_rate = this.calcRate(res2._param.online_pay_success_num, res2._param.online_pay_all_num)
                                            dataComp.online_pay_rate = this.calcRate(res3._param.online_pay_success_num, res3._param.online_pay_all_num)
                                            data.pay_put_user_rate = this.calcRate(data.put_sum, data.pay_sum)
                                            dataComp.pay_put_user_rate = this.calcRate(dataComp.put_sum, dataComp.pay_sum)
                                            //差值数据
                                            let data1 = {
                                                r_name: '差值',
                                                type: 1
                                            }
                                            data1.pay_num = data.pay_num - dataComp.pay_num
                                            data1.pay_ave = data.pay_ave - dataComp.pay_ave
                                            data1.pay_put_rate = data.pay_put_rate - dataComp.pay_put_rate
                                            data1.win_rate = data.win_rate - dataComp.win_rate
                                            data1.diff_rate = data.diff_rate - dataComp.diff_rate
                                            data1.pay_put_user_rate = data.pay_put_user_rate - dataComp.pay_put_user_rate
                                            data1.loss_rate = data.loss_rate - dataComp.loss_rate
                                            data1.pay_bet = data.pay_bet - dataComp.pay_bet
                                            data1.online_pay_rate = data.online_pay_rate - dataComp.online_pay_rate

                                            //环比数据
                                            let data2 = {
                                                r_name: '环比',
                                                type: 2
                                            }
                                            data2.pay_num = this.calcRate(data1.pay_num, dataComp.pay_num)
                                            data2.pay_ave = this.calcRate(data1.pay_ave, dataComp.pay_ave)
                                            data2.pay_put_rate = this.calcRate(data1.pay_put_rate, dataComp.pay_put_rate)
                                            data2.win_rate = data1.win_rate
                                            // dataComp.win_rate
                                            //     ? data1.win_rate / dataComp.win_rate
                                            //     : 0;
                                            data2.diff_rate = data1.diff_rate
                                            // dataComp.diff_rate
                                            //     ? data1.diff_rate /
                                            //       dataComp.diff_rate
                                            //     : 0;
                                            data2.pay_put_user_rate = data1.pay_put_user_rate
                                            // dataComp.pay_put_user_rate
                                            //     ? data1.pay_put_user_rate /
                                            //       dataComp.pay_put_user_rate
                                            //     : 0;
                                            data2.loss_rate = data1.loss_rate
                                            // dataComp.loss_rate
                                            //     ? data1.loss_rate /
                                            //       dataComp.loss_rate
                                            //     : 0;
                                            data2.pay_bet = this.calcRate(data1.pay_bet, dataComp.pay_bet)
                                            data2.online_pay_rate = this.calcRate(data1.online_pay_rate, dataComp.online_pay_rate)
                                            result.data = result.data.concat([data, data1, data2])
                                        }
                                    }
                                    let find = this.table.data.find((el) => el.platid == params.platid)
                                    if (find) {
                                        find.data.push(result)
                                    } else {
                                        this.panelName.push(`${params.platid}`)
                                        this.table.data.push({
                                            platid: params.platid,
                                            platname: params.platname,
                                            data: [result]
                                        })
                                    }
                                    loadingArr.shift()
                                    if (loadingArr.length == 0) this.closeTimer()
                                    this.toHttp(httpList, loadingArr)
                                }
                            })
                        })
                    })
                })
            }
        },
        getNeedField(data, item) {
            data.pay_num = item.pay_num
            data.pay_sum = item.pay_sum
            data.put_sum = item.put_sum
            data.pay_bet = item.pay_bet //投注转入比
            data.loss_rate = item.loss_rate //游戏盈利率
            data.win_num = item.win_num //赢家人数
            data.win_rate = item.win_rate //赢家数占比
            data.diff_rate = item.diff_rate
            data.pay_ave = this.calcRate(data.pay_sum, data.pay_num) //人均转入金额
            data.pay_put_rate = this.calcRate(data.pay_sum - data.put_sum, data.pay_sum) //充提差转入比
            data.pay_put_user_rate = this.calcRate(data.put_sum, data.pay_sum) //转入转出比
        },
        //分组变化清空盘口选择项
        updateSelect() {
            this.table.params.app_ids = []
        },
        toPdf() {
            this.panelName = this.table.data.map((el) => `${el.platid}`)
            this.$nextTick(() => {
                this.eleToPdf()
            })
        },
        rColItem(h, params) {
            let field = params.column.key
            let type = params.row.type
            let isRate = type == 2
            let value = params.row[field]
            let color = this.rCol(type, value)
            let str = isRate || field.includes('_rate') ? (value * 100 || 0).toFixed(2) + '%' : field.includes('_num') || field == 'pay_bet' ? this.getCustomFixed(value) : this.getCustomFixed(value / 10000)
            return h('span', { style: { color } }, str)
        },
        rCol(type, num) {
            if (type) {
                if (num > 0) {
                    return '#32CD32'
                } else if (num == 0) {
                    return '#333'
                } else if (num < 0) {
                    return 'red'
                }
            } else {
                return '#333'
            }
        }
    }
}
</script>

<style scoped lang="less">
.table-title {
    text-align: center;
    height: 50px;
    line-height: 50px;
}
/deep/ .ivu-collapse-content-box {
    padding-top: 0;
    padding-bottom: 0;
}
</style>
